import { Link } from "@tanstack/react-router";
import type { LucideIcon } from "lucide-react";
import { Settings, Users } from "lucide-react";
import { PageHeader } from "@/components/shared/page-header";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface AdminSection {
  title: string;
  description: string;
  href: string;
  icon: LucideIcon;
}

const sections: AdminSection[] = [
  {
    title: "Users",
    description: "Manage user accounts, roles, and permissions",
    href: "/admin/users",
    icon: Users,
  },
  {
    title: "Configuration",
    description: "Cost codes, task templates, milestone templates, and more",
    href: "/admin/config",
    icon: Settings,
  },
];

export function AdminPage() {
  return (
    <div className="space-y-6">
      <PageHeader title="Admin" description="System administration and configuration" />

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {sections.map((section) => (
          <Link key={section.href} to={section.href} className="group">
            <Card className="h-full transition-colors group-hover:border-primary/50">
              <CardHeader className="flex flex-row items-center gap-3 pb-2">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
                  <section.icon className="h-5 w-5" />
                </div>
                <CardTitle className="text-base">{section.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">{section.description}</p>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
